import * as React from 'react';
import styled from 'styled-components';

const StyledListItemAvatar = styled.div`
  margin-right: 8px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export class ListItemAvatar extends React.PureComponent<{}, {}> {
  public render() {
    return <StyledListItemAvatar>{this.props.children}</StyledListItemAvatar>;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/List/ListItemAvatar.tsx